export const SALE_TTL_ES = 'REPORTE DE VENTAS';

export interface ISaleDocumentBase {
  branchStoreName: string;
  pointSaleCode: string;
  clientName: string;
  clientNumberDocument: string;
  numberDocument: string;
  typeVoucher: string;
  methodPayment: string;
  statusSale: string;
  amount: number;
  base: number;
  igv: number;
  profitMargin: number;
  expAt: string;
  sortDate: Date | string;
  sortDatePeru?: string;
  hour: string;
  userUsername: string;
  producto: string;
  cantidad: number;
  precio: number;
  lote: string;
}

export interface ISaleDocument extends ISaleDocumentBase {
  id: number;
  tagStatusColor: string;
  tagPaymentMethodColor: string;
}
